// reducer.js

  interface TechnicalArea {
    id: number;
    created_at: string;
    updated_at: string;
    created_by_id: null;
    updated_by_id: null;
    name: string;
    code: null;
  }
 
  export interface TechnicalAreaState {
    data: TechnicalArea[];
    error: string | null;
  }
  
  export interface Action {
    type: string;
    payload: any;
  }
  
  const technicalAreainitialState: TechnicalAreaState = {
    data: [],
    error: null,
  };
  

  
  export const technicalAreaReducer = (
    state: TechnicalAreaState = technicalAreainitialState,
    action: Action
  ): TechnicalAreaState => {
    switch (action.type) {
      case "FETCH_TECHNICAL_AREA_SUCCESS":
        return { ...state, data: action.payload };
      case "FETCH_TECHNICAL_AREA_ERROR":
        return { ...state, error: action.payload };
      default:
        return state;
    }
  };
  